<!--  -->
<template>
  <div class="live-set" @click.self="hide(0)">
    <div class="box" @click.self="hide(1)">
      <div class="item" v-for="(item, i) in list" :key="i">
        <b>{{ item.name }}:</b>
        <img @click.self="change(item)" :src="item.isOPen ? openImg : closeImg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      openImg: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/live/live-open.png',
      closeImg: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/live/live-close.png',
      list: [
        {
          name: '直播间特效',
          isOPen: true,
          id: 'liveEffect',
        },
      ],
    };
  },
  props: {
    liveId: {
      type: String,
      default: '',
    },
  },
  computed: {},
  watch: {},
  methods: {
    change(item) {
      const { id, isOPen } = item;
      const arr = JSON.parse(JSON.stringify(this.list));
      arr.forEach((ele) => {
        if (ele.id === id) {
          Object.assign(ele, { isOPen: !ele.isOPen });
        }
      });
      this.list=arr;
      window.localStorage.setItem('liveSet',JSON.stringify(arr))
      if (isOPen) {
        window.localStorage.setItem(`${id}${this.liveId}`, 'close')
      } else {
        window.localStorage.removeItem(`${id}${this.liveId}`)
      }
    },
    hide(type) {
      console.log(type);
      if (type == '0') {
        this.$emit('closeLiveSet')
      }
    },
  },
  created() {},
  mounted() {
    const res = window.localStorage.getItem('liveSet');
    if (res) {
      this.list = JSON.parse(res);
    }
  },
};
</script>
<style lang="scss" scoped>
.live-set {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
}

.live-set .box {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 388px;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
}

.live-set .item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.live-set .item b {
    color: #FFF;
    font-weight: 500;
    font-size: 26px;
}
.live-set .item img{
    width: 78px;
    height: 44px;
    margin-left: 70px;
}
</style>
